
import * as React from 'react';
import { asAsync } from '../../utilities/components/Async';
import { IDecorateWithCurrentItemSetProps, ISpecifiedItemProps, getCurrentItemSetKey } from '../decorators/selectors';
import { IItemSetTilesListProps } from '../itemSetTilesList/ItemSetTilesList';
import { withItemSetSelection, IDecorateConnectToSelectionProps } from '../decorators/connectToSelection';
import { withPageLoadTracker, IDecorateWithPageLoadTrackerProps } from '../decorators/withPageLoadTracker';
import { asLayout, ILayoutProps, IDecorateAsLayoutProps } from '../layoutManager/LayoutManager';
import { connectToItemCache } from '../decorators/connectToItemCache';
import { tilesLayoutControl } from '../../controls/tilesLayoutControl';
import { IItemCache } from '../../models/IItemCacheObserver';
import { tilesLayoutType } from './TilesLayoutTypeFacet';
import { withSelectedItemsContextMenu, IDecorateWithSelectedItemsContextMenuProps } from '../decorators/withSelectedItemsContextMenu';

const AsyncTilesList = asAsync(async () => (
  await import(/* webpackChunkName: 'itemsettileslist' */'../itemSetTilesList/ItemSetTilesList')
).ItemSetTilesList);

const ContextMenuTilesList = withSelectedItemsContextMenu()(AsyncTilesList);

const AsyncTilesListWithSelection =
  withItemSetSelection()(ContextMenuTilesList);

const PageLoadTilesList = withPageLoadTracker([])(AsyncTilesListWithSelection);

const PageLoadTilesListLayout = asLayout(tilesLayoutType)(PageLoadTilesList);

export type ITilesLayoutProps = IDecorateAsLayoutProps<
  IDecorateWithCurrentItemSetProps<
  IDecorateWithPageLoadTrackerProps<
  IDecorateConnectToSelectionProps<
  IDecorateWithSelectedItemsContextMenuProps<
  IItemSetTilesListProps>,
  Pick<IItemSetTilesListProps, 'selection'>, {}>>>>;

export const TilesLayout: React.ComponentType<ITilesLayoutProps> = connectToItemCache((
  itemCache: IItemCache
): Pick<ILayoutProps, 'isAvailable'> & ISpecifiedItemProps => {
  const itemKey = getCurrentItemSetKey(itemCache);

  const controlHandler = itemCache.demandItemFacet(tilesLayoutControl, itemKey);

  const {
    itemKey: finalItemKey,
    isAvailable
  } = tilesLayoutControl.evaluate(controlHandler)(itemCache, {
    itemKey,
    isAvailable: true
  });

  return {
    isAvailable,
    itemKey: finalItemKey
  };
})(PageLoadTilesListLayout);

TilesLayout.displayName = 'TilesLayout';
